/**
 * Generic error class for creating loggable errors from any source.
 * Ensures errors are properly tracked by error monitoring services.
 *
 * @example
 * ```ts
 * // Wrap an unknown error
 * try {
 *   await somethingRisky();
 * } catch (error) {
 *   loggerService.error(new AppError('OperationFailed', error));
 * }
 *
 * // Create a new error
 * loggerService.error(new AppError('ValidationFailed', 'Invalid input'));
 * ```
 */
export class AppError extends Error {
  constructor(name: string, error: Error | string | unknown) {
    if (error instanceof Error) {
      // Preserve the original error's message and stack
      super(error.message);
      this.stack = error.stack;
      this.name = name;
    } else if (typeof error === "string") {
      super(error);
      this.name = name;
    } else {
      // Handle unknown types by stringifying them
      super(String(error));
      this.name = name;
    }
  }
}
